import { DocumentNode, gql } from '@apollo/client';
import { Box, HStack, Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { VenueFragment } from '@/fragments/venue-fragment';
import { EventVenueType } from '@/graphql-types/globalTypes';
import {
  GlobeIcon,
  MapPinIcon,
  PlayCircleIcon,
} from '@/imports/ui/chakra/feather';

import { EventLocation_EventFragment } from './graphql-types/EventLocation_EventFragment';

export const EventLocation: React.FC<{ event: EventLocation_EventFragment }> & {
  eventFragment: DocumentNode;
} = (props) => {
  if (props.event.__typename === 'ConferenceEventV2') {
    const inPersonLabel =
      props.event.inPersonLocation?.address?.name ||
      props.event.inPersonLocation?.address?.streetAddress ||
      props.event.inPersonLocation?.address?.locality ||
      'In Person';

    return (
      <Box>
        <HStack>
          {
            {
              [EventVenueType.ONLINE]: <GlobeIcon />,
              [EventVenueType.HYBRID]: (
                <HStack spacing="0.5">
                  <MapPinIcon />
                  <GlobeIcon />
                </HStack>
              ),
              [EventVenueType.IN_PERSON]: <MapPinIcon />,
            }[props.event.venueType]
          }
          <Text>
            {
              {
                [EventVenueType.ONLINE]: 'Online',
                [EventVenueType.HYBRID]: `${inPersonLabel} & Online`,
                [EventVenueType.IN_PERSON]: inPersonLabel,
              }[props.event.venueType]
            }
          </Text>
        </HStack>
      </Box>
    );
  }

  const inPersonLabel =
    props.event.venue.inPersonLocation?.address?.name ||
    props.event.venue.inPersonLocation?.address?.streetAddress ||
    props.event.venue.inPersonLocation?.address?.locality ||
    'In Person';

  const onlineLabel =
    props.event.venue.online?.__typename === 'EventVenue_TradewingPlatform'
      ? 'On Tradewing'
      : `On ${
          props.event.venue.online?.externalPlatformName || 'External Platform'
        }`;

  const onlineIcon =
    props.event.venue.online?.__typename === 'EventVenue_TradewingPlatform' &&
    props.event.venue.online.stream.__typename ===
      'EventVenue_TradewingPlatform_Stream_Prerecorded' ? (
      <PlayCircleIcon />
    ) : (
      <GlobeIcon />
    );

  return (
    <Box>
      <HStack>
        {
          {
            [EventVenueType.ONLINE]: onlineIcon,
            [EventVenueType.HYBRID]: (
              <HStack spacing="0.5">
                <MapPinIcon />
                {onlineIcon}
              </HStack>
            ),
            [EventVenueType.IN_PERSON]: <MapPinIcon />,
          }[props.event.venue.type]
        }
        <Text>
          {
            {
              [EventVenueType.ONLINE]: onlineLabel,
              [EventVenueType.HYBRID]: `${inPersonLabel} & ${onlineLabel}`,
              [EventVenueType.IN_PERSON]: inPersonLabel,
            }[props.event.venue.type]
          }
        </Text>
      </HStack>
    </Box>
  );
};

EventLocation.eventFragment = gql`
  fragment EventLocation_EventFragment on EventV2 {
    _id
    ... on SimpleEventV2 {
      venue {
        ...VenueFragment
      }
    }
    ... on ConferenceEventV2 {
      venueType
      inPersonLocation {
        address {
          name
          streetAddress
          locality
        }
      }
    }
  }
  ${VenueFragment}
`;
